import { Banknote, CreditCard, Landmark, Ticket, HelpCircle, DollarSign } from 'lucide-react';
import { METHOD_LABEL } from '../api';

/**
 * Cómo pagó, en un icono con tooltip (Carlos 15-ago: «pon el icono con un tooltip, igual que en
 * pagos»). El nombre completo sigue disponible al pasar el cursor y para lectores de pantalla —
 * el icono solo ahorra el renglón, no esconde el dato.
 */
const ICONO: Record<string, typeof Banknote> = {
  cash: Banknote,
  creditcard: CreditCard,
  card: CreditCard,
  wire: Landmark,   // el banco se reconoce mejor que unas flechas (Carlos 15-ago)
  voucher: Ticket,
  cash_usd: DollarSign,   // cuadrito «Dólares» del cobro (1-oct-2026); en BD es method='cash' + currency='USD'
};
const COLOR: Record<string, string> = {
  cash: 'text-emerald-600 dark:text-emerald-400',
  creditcard: 'text-sky-600 dark:text-sky-400',
  card: 'text-sky-600 dark:text-sky-400',
  wire: 'text-violet-600 dark:text-violet-400',
  voucher: 'text-teal-600 dark:text-teal-400',
  cash_usd: 'text-emerald-700 dark:text-emerald-300',
};

/**
 * `conTexto`: true = siempre · 'sm' = a partir de tablet · 'lg' = solo en escritorio.
 *
 * 🚨 El texto importa: al compactar las tablas para la tablet (18-sep-2026) se dejó solo el icono
 * y Karla echó de menos ver «efectivo / transferencia» escrito — es lo que mira para cuadrar.
 * Con icono Y palabra, salvo que de verdad no quepa.
 */
export default function MetodoPago({ metodo, conTexto = false, size = 15 }: {
  metodo: string; conTexto?: boolean | 'sm' | 'lg'; size?: number;
}) {
  const Icono = ICONO[metodo] || HelpCircle;
  const label = METHOD_LABEL[metodo] || metodo || 'Sin método';
  const claseTexto = conTexto === 'sm' ? 'hidden text-xs sm:inline'
    : conTexto === 'lg' ? 'hidden text-xs lg:inline'
    : 'text-xs';
  return (
    <span title={label} aria-label={label}
      className={`inline-flex items-center gap-1 ${COLOR[metodo] || 'text-content-3'}`}>
      <Icono size={size} className="shrink-0" />
      {conTexto && <span className={claseTexto}>{label}</span>}
    </span>
  );
}
